namespace SorAraBul.Definitions {
    export interface QuartersRow {
        Id?: number;
        Name?: string;
        DistrictName?: string;
        DistrictId?: number;
        IlceId?: number;
        IlceName?: string;
        IlceCityId?: number;
        CountryId?: number;
    }

    export namespace QuartersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Definitions.Quarters';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = '*';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            DistrictName = "DistrictName",
            DistrictId = "DistrictId",
            IlceId = "IlceId",
            IlceName = "IlceName",
            IlceCityId = "IlceCityId",
            CountryId = "CountryId"
        }
    }
}
